import { getAssociateTypesFromAssociate } from "./associateCapabilities";

export const PORTAL_TYPE_UI_OPTIONS = [
  { value: "online_school", labelKey: "portalType.onlineSchool" },
  { value: "jamia", labelKey: "portalType.jamia" },
  { value: "hifz_ul_quran", labelKey: "portalType.hifzUlQuran" },
];

export function portalTypeLabel(value, t) {
  const opt = PORTAL_TYPE_UI_OPTIONS.find((o) => o.value === value);
  return opt ? t(opt.labelKey) : value;
}

/** Options limited to tags present on the associate / affiliate object. */
export function portalOptionsForAssociate(associate) {
  const raw = getAssociateTypesFromAssociate(associate);
  const allowed = raw.filter((x) => PORTAL_TYPE_UI_OPTIONS.some((o) => o.value === x));
  const allowedSet = new Set(allowed);
  return PORTAL_TYPE_UI_OPTIONS.filter((o) => allowedSet.has(o.value));
}
